import { connect } from 'react-redux'
import { setLayoutModalInfo } from 'core/templates/actions'
import BasicLayout from './BasicLayout'

const mapStateToProps = state => ({
  configuration: state.configuration
})

const mapDispatchToProps = { setLayoutModalInfo }

export default connect(mapStateToProps, mapDispatchToProps)(BasicLayout)
